import { Box, Typography } from '@mui/material'
import { LightTooltip } from '../../../../LighTooltip'

interface ServiceKmsDetailsProps {
	isReserveService: boolean
	isSecondaryDriverService: boolean
	fleetNumber: string
	calculations: {
		executedTotalKmsInNotEmpty: number
		scheduledTotalKmsInNotEmpty: number
		showTotalKmsInNotEmptyTooltip: boolean
		executedTotalKmsInEmpty: number
		scheduledTotalKmsInEmpty: number
		showTotalKmsInEmptyTooltip: boolean
		executedTotalKms: number
		scheduledTotalKms: number
		showTotalKmsTooltip: boolean
	}
	tooltipState: {
		totalKmsInNotEmptyTooltipOpen: boolean
		setTotalKmsInNotEmptyTooltipOpen: (open: boolean) => void
		totalKmsEmptyTooltipOpen: boolean
		setTotalKmsEmptyTooltipOpen: (open: boolean) => void
		totalKmsTooltipOpen: boolean
		setTotalKmsTooltipOpen: (open: boolean) => void
	}
}

export default function ServiceKmsDetails({
	isReserveService,
	isSecondaryDriverService,
	fleetNumber,
	calculations,
	tooltipState,
}: Readonly<ServiceKmsDetailsProps>) {
	const getTooltipTitle = (scheduled: number, executed: number) =>
		scheduled > executed ? 'Inferior ao Valor Escalado' : 'Excede o Valor Escalado'

	const typographyStyle = (showWarning: boolean) => ({
		margin: 'auto 0',
		fontFamily: 'var(--font-family)',
		fontWeight: 400,
		fontSize: '12px',
		lineHeight: '130%',
		letterSpacing: '0.17px',
		color: isSecondaryDriverService ? 'var(--primary-light)' : showWarning ? 'var(--warning)' : 'var(--primary-dark)',
	})

	return (
		<Box sx={{ display: 'grid', gap: '0.25rem', margin: 'auto 0', padding: '0.75rem 1rem' }}>
			<Typography
				sx={{
					fontFamily: 'var(--font-family)',
					fontWeight: 400,
					fontSize: '12px',
					lineHeight: '130%',
					letterSpacing: '0.17px',
					color: 'var(--primary-dark)',
				}}
			>
				{fleetNumber}
			</Typography>
			{isReserveService ? (
				'-'
			) : (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 1,
						fontFamily: 'var(--font-family)',
						fontWeight: 400,
						fontSize: '12px',
						lineHeight: '130%',
						letterSpacing: '0.17px',
						color: 'var(--primary-dark)',
					}}
				>
					<LightTooltip
						title={getTooltipTitle(calculations.scheduledTotalKmsInNotEmpty, calculations.executedTotalKmsInNotEmpty)}
						open={tooltipState.totalKmsInNotEmptyTooltipOpen && calculations.showTotalKmsInNotEmptyTooltip}
						onOpen={() => tooltipState.setTotalKmsInNotEmptyTooltipOpen(true)}
						onClose={() => tooltipState.setTotalKmsInNotEmptyTooltipOpen(false)}
						placement='top'
					>
						<Typography
							variant='body2'
							sx={typographyStyle(calculations.showTotalKmsInNotEmptyTooltip)}
						>
							{calculations.executedTotalKmsInNotEmpty}
						</Typography>
					</LightTooltip>
					<span style={{ color: isSecondaryDriverService ? 'var(--primary-light)' : 'var(--primary-dark)' }}>/</span>
					<LightTooltip
						title={getTooltipTitle(calculations.scheduledTotalKmsInEmpty, calculations.executedTotalKmsInEmpty)}
						open={tooltipState.totalKmsEmptyTooltipOpen && calculations.showTotalKmsInEmptyTooltip}
						onOpen={() => tooltipState.setTotalKmsEmptyTooltipOpen(true)}
						onClose={() => tooltipState.setTotalKmsEmptyTooltipOpen(false)}
						placement='top'
					>
						<Typography
							variant='body2'
							sx={typographyStyle(calculations.showTotalKmsInEmptyTooltip)}
						>
							{calculations.executedTotalKmsInEmpty}
						</Typography>
					</LightTooltip>
					<span style={{ color: isSecondaryDriverService ? 'var(--primary-light)' : 'var(--primary-dark)' }}>/</span>
					<LightTooltip
						title={getTooltipTitle(calculations.scheduledTotalKms, calculations.executedTotalKms)}
						open={tooltipState.totalKmsTooltipOpen && calculations.showTotalKmsTooltip}
						onOpen={() => tooltipState.setTotalKmsTooltipOpen(true)}
						onClose={() => tooltipState.setTotalKmsTooltipOpen(false)}
						placement='top'
					>
						<Typography
							variant='body2'
							sx={typographyStyle(calculations.showTotalKmsTooltip)}
						>
							{calculations.executedTotalKms}
						</Typography>
					</LightTooltip>
				</Box>
			)}
		</Box>
	)
}
